import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, Shield, FileText } from 'lucide-react';
export function SystemOverview() {
  const benefits = [{
    icon: CheckCircle,
    title: 'MÁS ORDEN DESDE LA PRIMERA ENTREVISTA',
    description: 'Sabés qué evaluar, qué preguntar, qué observar y cómo organizar la información clínica del geronte sin depender de "ver qué aparece".'
  }, {
    icon: Shield,
    title: 'MÁS SEGURIDAD PROFESIONAL',
    description: 'Tenés protocolos para vínculo terapéutico, duelo, deterioro cognitivo leve, familia, contexto institucional y cierre del proceso.'
  }, {
    icon: FileText,
    title: 'MÁS ESTRUCTURA EN CADA ETAPA',
    description: 'No es teoría abstracta sobre vejez. Son guías, plantillas, preguntas clínicas y recursos prácticos para aplicar en el trabajo terapéutico real con adultos mayores.'
  }];
  return <section className="w-full py-16 md:py-24 bg-white" data-id="element-124">
      <div className="max-w-6xl mx-auto px-4 md:px-6" data-id="element-125">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-126">
          <h2 className="text-3xl md:text-4xl font-bold text-[#14505c] mb-4" data-id="element-127">
            UN SISTEMA PARA TRABAJAR CON GERONTES CON MÁS CLARIDAD CLÍNICA
          </h2>
          <div className="max-w-4xl mx-auto space-y-4 text-gray-600" data-id="element-128">
            <p data-id="element-129">
              Este kit te ayuda a conducir el proceso terapéutico con adultos
              mayores desde la primera consulta, integrando evaluación
              emocional, funcionamiento cognitivo, autonomía, red familiar,
              pérdidas, contexto institucional y criterios de cierre.
            </p>
          </div>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-130">
          {benefits.map((benefit, index) => {
          const Icon = benefit.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: index * 0.1
          }} className="bg-[#faf9f7] p-6 rounded-lg border border-gray-200" data-id="element-131">
                <Icon className="w-12 h-12 text-[#d97706] mb-4" data-id="element-132" />
                <h3 className="text-lg font-bold text-[#14505c] mb-3" data-id="element-133">
                  {benefit.title}
                </h3>
                <p className="text-gray-600" data-id="element-134">{benefit.description}</p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}